"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/switch/style/index.js
// module id = 92
// module chunks = 1